import { useEffect, useMemo, useState } from "react";
import { useOnlineStatus } from "../../sg-hooks/useOnlineStatus";
import { useOfflineStorage } from "./useOfflineStorage";
import { keyInterface } from "swr";

export type UseOfflineCacheData = {
    getItem: <T = any> (key: keyInterface) => T | null;
    setItem: <T = any>(key: keyInterface, value: T) => void;
    clearItem: (key: keyInterface) => any;

    online: boolean;
};

type UseOfflineCacheHook = () => UseOfflineCacheData;

export const useOfflineCache: UseOfflineCacheHook = () => {

    const storage = useOfflineStorage("offline-cache");

    const networkStatus = useOnlineStatus();

    const [online, setOnline] = useState(networkStatus);


    const resolveKey = (key: keyInterface): string => {
        if (typeof key === "function") {
            return resolveKey(key());
        };
        if (Array.isArray(key)) {
            return key.join("@")
        };
        if (typeof key === "string") {
            return key
        };
        return "null"
    };

    const getItem = <T = any>(key: keyInterface): T | null => {
        return storage.getItem(resolveKey(key))
    };

    const setItem = <T = any>(key: keyInterface, value: T) => {
        storage.setItem(resolveKey(key), value);
    }

    const clearItem = (key: keyInterface) => {
        storage.clearItem(resolveKey(key));
    }

    useEffect(() => {
        if (online) {
            storage.clearStorage()
        }
    }, [online]);  // eslint-disable-line

    useEffect(() => {
        setOnline(networkStatus);
    }, [networkStatus])


    return useMemo(() => ({
        online,
        getItem,
        setItem,
        clearItem,
    }), [online]);  // eslint-disable-line
};
